﻿/* ============================================================
   dxCtrlSondageQuestionChkRadioConsolide
   Composant consolidé pour une question à choix — gère à la fois
   le "choix unique" (radio, 1 réponse) et le "choix multiple"
   (checkbox, plusieurs réponses possibles), pilotés par
   option.type.

   100% styles inline : aucune balise <style>, aucune classe CSS,
   aucun pseudo-élément (::after/:hover). Le tooltip au survol est
   géré en JS (mouseenter/mouseleave). Seule dépendance : jQuery.

   Usage — choix unique (radio) :
     $("#q1").dxCtrlSondageQuestionChkRadioConsolide({
         type: "unique",
         titre: "Quel est votre secteur d'activité ?",
         dataSource: [
             { txt: "Retail / e-commerce", nb: 18 },
             { txt: "Conseil",             nb: 12 },
             { txt: "Industrie",           nb: 9  },
             { txt: "Autre",               nb: 11 }
         ]
     });
     // Le nombre de réponses ("Option unique · N réponses") est déduit
     // automatiquement de la somme des "nb".

   Usage — choix multiple (checkbox) :
     $("#q2").dxCtrlSondageQuestionChkRadioConsolide({
         type: "multiple",
         titre: "Quels canaux utilisez-vous pour nous contacter ?",
         totalRepondants: 50,   // requis : la somme des "nb" peut dépasser ce total
         dataSource: [
             { txt: "Email",           nb: 41 },
             { txt: "Chat en ligne",   nb: 33 },
             { txt: "Téléphone",       nb: 19 },
             { txt: "Réseaux sociaux", nb: 8  }
         ]
     });
     // Chaque pourcentage est calculé par rapport à totalRepondants
     // (et non à la somme des "nb", qui peut dépasser 100 % en cumulé).

   Si "type" est omis, le composant se comporte en "unique" (rétro-
   compatible avec l'ancien dxCtrlSondageQuestionOptConsolide).
   ============================================================ */

$.fn.dxCtrlSondageQuestionChkRadioConsolide = function custom_dxCtrlSondageQuestionChkRadioConsolide(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlsondagequestionchkradioconsolide dx-ctrl");
        this.createInstance(new cdxCtrlSondageQuestionChkRadioConsolide(this, option));
    }
    return this;
}

window.cdxCtrlSondageQuestionChkRadioConsolide = function (container, option) {
    var Me = this;

    // Habillage du badge / sous-titre selon le type de question
    var CONFIG_TYPE = {
        unique: {
            badgeTxt: "Choix unique",
            badgeBg: "#fdece4",
            badgeColor: "#eb6834"
        },
        multiple: {
            badgeTxt: "Choix multiple",
            badgeBg: "#eeecfa",
            badgeColor: "#4a3aa7"
        }
    };

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            dx.option(name, value);
        }
    }

    function mFormateNombre(n) {
        return n.toLocaleString("fr-FR");
    }

    function mFormatePourcentage(pct) {
        return pct.toLocaleString("fr-FR", { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + " %";
    }

    function mFormateReponses(n) {
        return mFormateNombre(n) + (n > 1 ? " réponses" : " réponse");
    }

    function mFormateRepondants(n) {
        return mFormateNombre(n) + (n > 1 ? " répondants" : " répondant");
    }

    function mConstruit() {
        container.empty();

        var dataSource = option.dataSource || [];
        var palette = option.palette || PALETTE_DEFAUT;
        var type = (option.question.type === "chk") ? "multiple" : "unique";
        var totalReponses = option.nb_repondant;

        // Base de calcul des pourcentages : le total de répondants pour le
        // choix multiple (fourni explicitement, la somme des nb pouvant
        // dépasser 100 % cumulés), la somme des réponses pour le choix unique.
        var base = (type === "chk")
            ? (option.nb_repondant != null ? option.nb_repondant : totalReponses)
            : totalReponses;

        // ---- En-tête : titre de la question, sous-titre, badge de type ----
        //if (option.question.text_intro) {
        var cfg = CONFIG_TYPE[type];
        var titre = $("<div>").html(option.question.text_intro || "").text()

        var $titre = $("<h3>").text(titre).css({
            fontSize: "14px",
            fontWeight: "600",
            margin: "0 0 5px",
            color: "#0b0b0b"
        });

        var texteSousTitre = (type === "multiple")
            ? "Choix multiple · " + mFormateRepondants(base) + " · plusieurs réponses possibles"
            : "Option unique · " + mFormateReponses(totalReponses);

        if (type == "unique" && option.question.calcul_satisfaction) {
            var result = option.sondageConsolide.mGetTauxSatisfaction(option.question)
            var txSatisfaction = ""
            if (result) {
                txSatisfaction = result.tx.formatDisplay(2) + "%"
            } else { txSatisfaction = "---" }
            texteSousTitre += " · Satisfaction " + txSatisfaction
        }

        var $sousTitre = $("<div>").html(texteSousTitre).css({
            fontSize: "12.5px",
            color: "#898781"
        });

        var $titres = $("<div>").css({
            display: "flex",
            flexDirection: "column",
            gap: "5px",
            minWidth: "0"
        }).append($titre, $sousTitre);

        var $badge = $("<span>").text(cfg.badgeTxt).css({
            flex: "none",
            fontSize: "11px",
            fontWeight: "700",
            padding: "4px 10px",
            borderRadius: "999px",
            whiteSpace: "nowrap",
            background: cfg.badgeBg,
            color: cfg.badgeColor
        });

        var $entete = $("<div>").css({
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
            gap: "12px",
            marginBottom: "14px"
        }).append($titres, $badge);

        container.append($entete);
        //}

        var $barchart = $("<div>").css({
            display: "flex",
            flexDirection: "column",
            gap: "12px"
        });

        dataSource.forEach(function (item, index) {
            var nb = item.nb || 0;
            var pct = base > 0 ? (nb / base * 100) : 0;
            var couleur = palette[index % palette.length];

            var $swatch = $("<span>").css({
                width: "10px",
                height: "10px",
                borderRadius: "3px",
                flex: "none",
                display: "inline-block",
                background: couleur
            });

            var $texte = $("<span>", { title: item.txt }).text(item.txt).css({
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap"
            });

            var $label = $("<div>").css({
                display: "flex",
                alignItems: "center",
                gap: "8px",
                fontSize: "13.5px",
                color: "#0b0b0b",
                minWidth: "0"
            }).append($swatch, $texte);

            //var $fill = $("<div>").css({
            //    position: "absolute",
            //    top: "0",
            //    bottom: "0",
            //    left: "0",
            //    borderRadius: "4px",
            //    transition: "width 0.6s ease",
            //    width: Math.max(pct, pct > 0 ? 0.6 : 0) + "%",
            //    background: couleur
            //});

            var $track = $("<div>").css({
                position: "relative",
                height: "22px",
                //background: "#e1e0d9",
                borderRadius: "4px",
                overflow: "hidden"
            }) //.append($fill);
            $("<div/>").appendTo($track).dxCtrlLinearJauge2Value({
                value: Math.max(pct, pct > 0 ? 0.6 : 0),
                color1: couleur,
                color2: "lightgray",
                height:22,
                showIndicator: false
            })

            var $count = $("<div>").css({
                fontSize: "13px",
                color: "#52514e",
                textAlign: "right",
                fontVariantNumeric: "tabular-nums"
            }).append(
                $("<strong>").text(mFormateNombre(nb)).css({ color: "#0b0b0b", fontWeight: "700" }),
                document.createTextNode(" · " + mFormatePourcentage(pct))
            );

            var $row = $("<div>").css({
                display: "grid",
                gridTemplateColumns: "176px 1fr 88px",
                alignItems: "center",
                gap: "12px"
            }).append($label, $track, $count);

            $barchart.append($row);
        });

        if (dataSource.length === 0) {
            $barchart.append(
                $("<div>").text("Aucune donnée à afficher.").css({
                    fontSize: "13px",
                    color: "#898781",
                    fontStyle: "italic"
                })
            );
        }

        container.append($barchart);
    }

    this.element = function () { return container; }
    this.component = function () { return Me; }

    mConstruit();
}